import React from "react";
import ReactPlayer from "react-player";
import Cookies from "js-cookie";
// import Duration from "./Duration";

import { VideoEndModal } from "../../modals";
import challengesService from "../../../services/challengesService";
import ktkService from "../../../services/ktkService";

import "./videoViewer.scss";

class VideoViewer extends React.Component {
  state = {
    // url: null,
    // playing: false,
    // volume: 1,
    // played: 0,
    // duration: 0,
    // playbackRate: 1.0,
    openEndModal: false,
    earnedPoint: false,
    fullScreen: false,
  };

  // handlePlayPause = () => {
  //   this.setState({ playing: !this.state.playing });
  // };

  // handleSetPlaybackRate = (e) => {
  //   this.setState({ playbackRate: parseFloat(e.target.value) });
  // };

  // handlePlay = () => {
  //   this.setState({ playing: true });
  // };

  // handlePause = () => {
  //   this.setState({ playing: false });
  // };

  // handleSeekMouseDown = (e) => {
  //   this.setState({ seeking: true });
  // };

  // handleSeekChange = (e) => {
  //   this.setState({ played: parseFloat(e.target.value) });
  // };

  // handleSeekMouseUp = (e) => {
  //   this.setState({ seeking: false });
  //   this.player.seekTo(parseFloat(e.target.value));
  // };

  // handleProgress = (state) => {
  //   if (!this.state.seeking) {
  //     this.setState(state);
  //   }
  // };

  handleEnded = () => {
    if (!this.props.withoutHandlers) {
      if (this.props.handlers === "challenges") {
        challengesService
          .addChallengePoint(this.props.categoryId, this.props.challengeId)
          .then((res) => {
            if (res.data.result === "video watched") {
              this.setState({ earnedPoint: false });
            } else if (res.data.result === "point earned") {
              this.setState({ earnedPoint: true });
              if (window.location.hostname === "localhost") {
                Cookies.set("point_earned", true, { domain: "localhost" });
              } else if (window.location.hostname !== "localhost") {
                Cookies.set("point_earned", true, {
                  domain: ".bluemanoracademy.com",
                });
              }
            }
            this.setState({ openEndModal: true });
          });
      }

      if (this.props.handlers === "ktk" && this.props.user !== "manager") {
        ktkService
          .addChannelVideoPoint(this.props.channelId, this.props.videoId)
          .then((res) => {
            if (res.data.result === "video watched") {
              this.setState({ earnedPoint: false });
            } else if (res.data.result === "point earned") {
              this.setState({ earnedPoint: true });
              if (window.location.hostname === "localhost") {
                Cookies.set("point_earned", true, { domain: "localhost" });
              } else if (window.location.hostname !== "localhost") {
                Cookies.set("point_earned", true, {
                  domain: ".bluemanoracademy.com",
                });
              }
            }
            this.setState({ openEndModal: true });
          });
      }
    }
  };

  handleStarted = () => {
    if (!this.props.withoutHandlers) {
      if (this.props.handlers === "challenges") {
        challengesService.addChallengeView(
          this.props.categoryId,
          this.props.challengeId,
        );
      }

      if (this.props.handlers === "challengesAnswerView") {
        let newData = {
          user_id: this.props.userId,
          ids: [this.props.videoId],
        };
        challengesService.addChallengeAnswerView(
          this.props.categoryId,
          this.props.challengeId,
          newData,
        );
      }

      if (this.props.handlers === "ktk") {
        ktkService.addChannelVideoView(
          this.props.channelId,
          this.props.videoId,
        );
      }
    }
  };

  handleFullScreen = () => {
    let rootDiv = document.getElementById("root");
    document.body.style.overflow = "hidden";
    rootDiv.style.overflow = "hidden";
    if (!this.state.fullScreen) {
      document.body.style.overflow = "hidden";
      rootDiv.style.overflow = "hidden";
      window.scrollTo(0, 0);
      this.setState({ fullScreen: true });
    } else {
      document.body.style.overflow = "hidden auto";
      rootDiv.style.overflow = "unset";
      this.setState({ fullScreen: false });
    }
  };

  // handleDuration = (duration) => {
  //   this.setState({ duration });
  // };

  // ref = (player) => {
  //   this.player = player;
  // };

  render() {
    return (
      <>
        <div
          className={`videoBlock ${this.state.fullScreen && "fullScreenBlock"}`}
        >
          <h2 className="title">{this.props.title}</h2>

          <div className="videoPlayer">
            <ReactPlayer
              width="100%"
              height="100%"
              url={this.props.videoUrl}
              controls
              playsinline
              config={{
                vimeo: {
                  playerOptions: {
                    playsinline: 1,
                    muted: false,
                  },
                },
              }}
              onEnded={this.handleEnded}
              onStart={this.handleStarted}
            />
          </div>
        </div>

        {this.state.openEndModal && (
          <VideoEndModal
            closeModal={() => {
              this.setState({ openEndModal: false });
            }}
            earnedPoint={this.state.earnedPoint}
          />
        )}
      </>
    );
  }
}

export default VideoViewer;
